import React from 'react';
import { Orientation } from '@wix/ambassador-file-sharing-v1-settings/types';
import { setSort } from '../../../../../../Services/Sort.service';
import { SortDown, SortUp } from '@wix/wix-ui-icons-common/on-stage';
import { ActionsMenuLayout } from '@wix/wix-ui-tpa/cssVars';
import { setSelectedFolder } from '../../../../../../Services/SelectedFolder.service';
import { setIsLoading } from '../../../../../../Services/Loading.service';
import { changeSortDirection, getButtonDescriptionBi } from './helpers';
import biService from '../../../../../../BiEvents/BiService';
import { BI_FILE_SHARE_WIDGET_SORT_BY } from '../../../../../../BiEvents/Constants/BiConstants';
import { st, classes } from './ActionsMenuLayoutComponent.st.css';

const customBuildActionsMenuLayoutItem = ({
  id,
  content,
  sortBy,
  orientation,
  selectedFolderId,
  isMobile,
  setIsOpen,
}: any) => {
  const handleOnClick = ({ selectedId }: any) => {
    if (sortBy === selectedId) {
      const tempOrientation = changeSortDirection({ orientation });
      setSort({ sortBy: selectedId, orientation: tempOrientation });
    } else {
      setSort({ orientation, sortBy: selectedId });
    }
    setIsLoading(true);
    setSelectedFolder(selectedFolderId);
    if (isMobile) {
      setIsOpen && setIsOpen(false);
    }
  };
  const PrefixIcon: any =
    sortBy === id ? (
      orientation === Orientation.DESC ? (
        <SortDown className={st(classes.sortArrow)} aria-hidden="true" />
      ) : (
        <SortUp className={st(classes.sortArrow)} aria-hidden="true" />
      )
    ) : (
      <div></div>
    );
  return (
    <ActionsMenuLayout.Item
      key={id}
      onClick={() => {
        handleOnClick({
          selectedId: id,
        });
        biService(
          {
            button_description: getButtonDescriptionBi(id),
            is_first: false,
          },
          BI_FILE_SHARE_WIDGET_SORT_BY,
        );
      }}
      content={content}
      prefixIcon={PrefixIcon}
    />
  );
};
export default customBuildActionsMenuLayoutItem;
